module.exports = __webpack_public_path__ + "static/media/BackgroundRepeat_RM-V1.117c8f1c.png";